import React, { memo } from 'react';
import PropTypes from 'prop-types';

const Text = ({ content }) => (
  <div className="text-wrapper" dangerouslySetInnerHTML={{__html: content}}></div>
);

Text.propTypes = {
  content: PropTypes.string.isRequired,
};
export default memo(Text);
